var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DA0D46;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 439.3,
    cy: 440.7,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,557.1H87.3l80.3-232.7h63.4l80.2,232.7h-52.7l-58.3-179.5h-1.8L140.1,557.1z M136.8,465.6h124.5V504 H136.8V465.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.8,324.3h60.7l64.1,156.4h2.7l64.1-156.4H580v232.7h-47.7V405.6h-1.9l-60.2,150.3h-32.5L377.4,405h-1.9 v152h-47.7V324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.1,364.9v-40.6h191.1v40.6H720v192.2h-48.6V364.9H600.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmtIcon);
export default __webpack_public_path__ + "static/media/amt_icon.d6411f8d6094ba57cb7e3cfefe54e0d6.svg";
export { ForwardRef as ReactComponent };